<template>
	<div class="flex gap-1.5">
		<BaseTag
			v-for="item in tagsComputed"
			@click="setActive(item.i)"
			:active="active === item.i"
			:disabled="item.disabled || disabled"
		>
			<Component v-if="item.icon" :is="item.icon" class="h-5 w-5" />
			<BasePrice v-if="price" :price="Number(item.text)" />
			<div v-else>{{ item.text }}</div>
		</BaseTag>
	</div>
</template>
<script setup lang="ts">
import { computed, type Component } from 'vue'
import BaseTag from './BaseTag.vue'
import BasePrice from './BasePrice.vue'

const props = defineProps<{
	tags: {
		text: string
		icon?: string | Component
		disabled?: boolean
		hidden?: boolean
	}[]
	disabled?: boolean
	price?: boolean
}>()

const active = defineModel<number>()

const setActive = (value: number) => {
	if (props.disabled || props.tags[value].disabled) {
		return
	}

	active.value = value
}

const tagsComputed = computed(() =>
	props.tags
		.map((tag, i) => ({
			...tag,
			i
		}))
		.filter((tag) => !tag.hidden)
)
</script>
